// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b8cf1288","39":"4228d6a0","634":"e5ed0b22","777":"f0835fac","799":"bd16294b","821":"37df9910"}[chunkId] + ".chunk.js";
};